var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.label)?_c('div',{staticClass:"asd20-list-category"},[_c('div',{staticClass:"asd20-list-category__label",domProps:{"innerHTML":_vm._s(_vm.label)}}),(_vm.badge)?_c('asd20-badge',{attrs:{"value":_vm.badge}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }